"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order content-right"
  }, [_c("div", {
    staticClass: "body"
  }, [_c("div", {
    staticClass: "filter"
  }, [_c("el-form", {
    staticClass: "filter-inline",
    attrs: {
      inline: true,
      model: _vm.filterItem
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("gdgl.entryName")
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("gdgl.entryName")
    },
    model: {
      value: _vm.filterItem.entryName,
      callback: function callback($$v) {
        _vm.$set(_vm.filterItem, "entryName", $$v);
      },
      expression: "filterItem.entryName"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("gdgl.workOrderType")
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: _vm.$t("gdgl.workOrderType")
    },
    model: {
      value: _vm.filterItem.workOrderType,
      callback: function callback($$v) {
        _vm.$set(_vm.filterItem, "workOrderType", $$v);
      },
      expression: "filterItem.workOrderType"
    }
  }, [_c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.all"),
      value: ""
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.deviceFailure"),
      value: "1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.other"),
      value: "2"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("gdgl.workOrderStatus")
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: _vm.$t("gdgl.workOrderStatus")
    },
    model: {
      value: _vm.filterItem.workOrderStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.filterItem, "workOrderStatus", $$v);
      },
      expression: "filterItem.workOrderStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.all"),
      value: ""
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.pending"),
      value: "0"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.processing"),
      value: "1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.$t("gdgl.closed"),
      value: "2"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", {
    staticClass: "picker_time",
    attrs: {
      label: _vm.$t("gdgl.filterTime")
    }
  }, [_c("el-date-picker", {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      type: "daterange",
      align: "right",
      "unlink-panels": "",
      "range-separator": "-",
      "start-placeholder": _vm.$t("gdgl.startDate"),
      "end-placeholder": _vm.$t("gdgl.endDate")
    },
    model: {
      value: _vm.filterItem.filterTime,
      callback: function callback($$v) {
        _vm.$set(_vm.filterItem, "filterTime", $$v);
      },
      expression: "filterItem.filterTime"
    }
  })], 1), _vm._v(" "), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("gdgl.submit")) + "\n          ")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("gdgl.reset")) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "tablebody"
  }, [_c("div", {
    staticClass: "tablebody-title"
  }, [_c("el-menu", {
    attrs: {
      "default-active": _vm.activeName,
      mode: "horizontal"
    },
    on: {
      select: _vm.handleActiveName
    }
  }, [_c("el-menu-item", {
    attrs: {
      index: "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.submit")))]), _vm._v(" "), _c("el-menu-item", {
    attrs: {
      index: "review"
    }
  }, [_vm.missOrderCount > 0 ? [_c("el-badge", {
    attrs: {
      value: _vm.missOrderCount
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.review")))])] : [_vm._v("\n              " + _vm._s(_vm.$t("gdgl.review")) + "\n            ")]], 2), _vm._v(" "), _c("el-menu-item", {
    attrs: {
      index: "send"
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.send")))])], 1)], 1), _vm._v(" "), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      "header-cell-style": {
        "text-align": "center"
      },
      "cell-style": {
        "text-align": "center"
      },
      "max-height": 650 + "px",
      "cell-class-name": _vm.cellStyle
    }
  }, [_vm._l(_vm.column, function (item, key) {
    return [item.prop != "handlerTypeName" ? _c("el-table-column", {
      key: key,
      attrs: {
        type: item.type,
        prop: item.prop,
        label: item.label,
        width: item.width,
        "min-width": item.minWidth
      }
    }) : _vm._e(), _vm._v(" "), _vm.activeName == "review" && item.prop == "handlerTypeName" ? _c("el-table-column", {
      key: key,
      attrs: {
        type: item.type,
        prop: item.prop,
        label: item.label,
        width: item.width,
        "min-width": item.minWidth
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_c("span", {
            staticClass: "handleValueLabel"
          }, [_vm._v("\n                " + _vm._s(scope.row.handlerTypeName) + "\n              ")])];
        }
      }], null, true)
    }) : _vm._e()];
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      width: "250",
      label: _vm.$t("gdgl.action")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm.activeName == "submit" ? _c("el-button", {
          staticClass: "showInfo",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleEditInfo(row);
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t("gdgl.edit")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c("el-button", {
          staticClass: "showInfo",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleInfo(row);
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t("gdgl.view")) + "\n            ")])];
      }
    }])
  })], 2)], 1)]), _vm._v(" "), _c("el-dialog", {
    staticClass: "order-el-dialog",
    attrs: {
      title: _vm.$t("gdgl.edit"),
      visible: _vm.editStatus,
      width: "600px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editStatus = $event;
      }
    }
  }, [_c("div", {
    staticClass: "order-edit"
  }, [_c("div", {
    staticStyle: {
      padding: "20px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.detail")))]), _vm._v(" "), _c("el-input", {
    staticStyle: {
      width: "100%",
      "font-size": "16px"
    },
    attrs: {
      type: "textarea",
      maxlength: "200",
      "show-word-limit": "",
      clearable: "",
      rows: "5",
      placeholder: _vm.$t("gdgl.detail"),
      resize: "none"
    },
    model: {
      value: _vm.editForm.detail,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "detail", $$v);
      },
      expression: "editForm.detail"
    }
  }), _vm._v(" "), _c("div", {
    staticStyle: {
      padding: "20px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.uploadImage")))]), _vm._v(" "), _c("el-upload", {
    ref: "elUpload",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      action: " ",
      "list-type": "picture-card",
      multiple: "",
      accept: ".jpg,.jpeg,.png,.JPG,.JPEG",
      "auto-upload": false,
      "on-change": _vm.handleUpload,
      limit: 4
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.editStatus = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.cancel")))]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.handleEdit("order");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("gdgl.confirm")))])], 1)])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;